import React from "react";
// ANT DESIGN COMPONENTS
import { Select } from "antd";
// CUSTOM HOOKS
import useGetAllOrganizationsLight from "../../../customHooks/GET_requests/useGetAllOrganizationsLight";
// INTERFACES
import { OganizationLightInterface } from "../../../interfaces/Organizations.interface";
import { SelectOrganizationInterface } from "../../../interfaces/Global.interface";

function SelectOrganizationsLight({ value, onChangeIdOrganization, disabledInput }: SelectOrganizationInterface) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const { Option } = Select;

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// CUSTOM HOOKS *********************************** */
	const { organizationsLight: organizations, isLoadingGetAllOrganizationsLight } = useGetAllOrganizationsLight();

	// ************************************************ */
	// FUNCTIONS ************************************** */

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<Select
			showSearch
			filterOption={(input: any, option: any) => option.children.toLowerCase().includes(input.toLowerCase())}
			size='small'
			loading={isLoadingGetAllOrganizationsLight}
			value={value}
			onChange={(item: string, record: any) => {
				onChangeIdOrganization(item, record);
			}}
			className='generalStyles__width100'
			disabled={disabledInput}
		>
			{organizations.map((item: OganizationLightInterface) => (
				<Option key={item.id} value={item.id}>
					{item.name}
				</Option>
			))}
		</Select>
	);
}

export default SelectOrganizationsLight;
